import { render, staticRenderFns } from "./findPassword.vue?vue&type=template&id=85238e96&scoped=true&"
import script from "./findPassword.vue?vue&type=script&lang=js&"
export * from "./findPassword.vue?vue&type=script&lang=js&"
import style0 from "./findPassword.vue?vue&type=style&index=0&id=85238e96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85238e96",
  null
  
)

export default component.exports